import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_likes = _resolveComponent("likes")!
  const _component_comments_counter = _resolveComponent("comments-counter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_likes, {
      likedContentUuid: _ctx.articleUuid,
      category: "article"
    }, null, 8, ["likedContentUuid"]),
    _createVNode(_component_comments_counter, {
      "article-uuid": _ctx.articleUuid,
      "use-bold-font": "",
      "article-url": _ctx.articleUrl,
      showSmall: true
    }, null, 8, ["article-uuid", "article-url"])
  ], 64))
}